import { useRef, useCallback } from "react"
import { Marker as MapboxMarker } from "mapbox-gl"
import type { MapRef } from "react-map-gl/mapbox"

export const useMapMarker = (mapRef: React.RefObject<MapRef | null>, color: string) => {
  const markerRef = useRef<MapboxMarker | null>(null)

  const onHover = useCallback(
    (lngLat: [number, number]) => {
      markerRef.current?.remove()
      const map = mapRef.current?.getMap()
      if (!map) return
      markerRef.current = new MapboxMarker({ color }).setLngLat(lngLat).addTo(map)
    },
    [mapRef, color],
  )

  const onLeave = useCallback(() => {
    markerRef.current?.remove()
    markerRef.current = null
  }, [])

  const remove = useCallback(() => {
    markerRef.current?.remove()
    markerRef.current = null
  }, [])

  return { onHover, onLeave, remove, markerRef }
}
